const INITIAL_STATE = {
  onImageSelect: () => {},
  show: false
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_GALERIA_IMAGEM':
      return {
        ...state,
        onImageSelect: action.onImageSelect,
        show: action.show
      };
    default:
      return state;
  }
}
